module.exports = __webpack_public_path__ + "img/stop-12.5b179753.jpg";